import templateOnly from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import { capitalize } from '@ember/string';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const DropdownItem = setComponentTemplate(precompileTemplate("\n  <div class={{concat \"item\" (if @unfilterable \" unfilterable disabled\")}} data-value={{@key}} ...attributes>\n    {{#if @value}}\n      {{@value}}\n    {{else if @translationKey}}\n      {{capitalize (t (concat @translationKey (concat \".\" @key)))}}\n    {{else}}\n      {{yield}}\n    {{/if}}\n  </div>\n", {
  strictMode: true,
  scope: () => ({
    concat,
    capitalize,
    t
  })
}), templateOnly(undefined, "item:DropdownItem"));
export default DropdownItem;